import React from 'react';
import { Container, Typography, Grid, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';

import SecondFooter from '../layout/SecondFooter';

// Redes oficiales de oneService. Para sumar otra (Instagram, YouTube…) basta con agregarla aquí.
const REDES = [
  { nombre: 'Facebook', url: 'https://www.facebook.com/oneServi', Icono: FacebookIcon },
  { nombre: 'X', url: 'https://x.com/oneservice11', Icono: XIcon },
];

const Footer = () => {
  const navigate = useNavigate();

  return (
    <Grid className="footer" sx={{
      backgroundColor: "primary.main",
      mt: 'auto',
      position: 'relative'
    }}>
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid container spacing={1} size={12}>
            <Grid className="content-logo" size={{ xs:12, sm:6 }} display="flex" mt={3}>
              <img alt="logo" width="224" src="/logo2.png" />
            </Grid>
            <Grid className="content-social" size={{ xs:12, sm:6 }}>
              {REDES.map(({ nombre, url, Icono }) => (
                <Link
                  key={nombre}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`oneService en ${nombre}`}
                  underline="none"
                  sx={{ display: 'inline-flex', borderRadius: '50%', '&:focus-visible': { outline: '2px solid white', outlineOffset: '2px' } }}
                >
                  <Icono className="btn-social" sx={{ color: 'primary.main', fontSize: {xs: 20, md: 20} }} />
                </Link>
              ))}
            </Grid>
          </Grid>
          <Grid sx={{ marginBottom: {xs: 0, sm: 3}, marginTop: {xs: 2, md: 0} }} size={{ xs:12, sm:4 }}>
            <Typography component="h2" className="titulo-footer">Únete a nuestro círculo de servicios</Typography>
            <Link variant="body1" component="button" onClick={() => navigate("/buscar")} underline="none" color="textSecondary">
              Contrata un servicio
            </Link><br />
            {/* Sin sesión, PrivateRoute manda a entrar (o a crear la cuenta) y regresa aquí */}
            <Link variant="body1" component="button" onClick={() => navigate("/user/crear-servicio/0")} underline="none" color="textSecondary">
              Ofrece tus servicios
            </Link><br />
            <Link variant="body1" component="button" onClick={() => navigate("/user/crear-servicio/1?type=group")} underline="none" color="textSecondary">
              Abre un establecimiento de negocio
            </Link>
          </Grid>
          <Grid sx={{ marginBottom: {xs: 0, sm: 3}, marginTop: {xs: 2, md: 0} }} size={{ xs:12, sm:4 }} >
            {/* Mientras no haya una página «Acerca de», la pregunta «¿Qué es OneService?» de Ayuda */}
            <Link variant="body1" component="button" onClick={() => navigate("/ayuda#que-es-oneservice")} underline="none" color="textSecondary">
              Acerca de oneService
            </Link><br />
            <Link variant="body1" component="button" onClick={() => navigate("/terminos-condiciones")} underline="none" color="textSecondary">
              Términos y condiciones
            </Link><br />
            <Link variant="body1" component="button" onClick={() => navigate("/condiciones-uso")} underline="none" color="textSecondary">
              Condiciones de uso
            </Link><br />
            <Link variant="body1" component="button" onClick={() => navigate("/cookies")} underline="none" color="textSecondary">
              Políticas de cookies
            </Link><br />
            <Link variant="body1" component="button" onClick={() => navigate("/privacidad")} underline="none" color="textSecondary">
              Políticas de privacidad
            </Link>
          </Grid>
          <Grid sx={{ marginBottom: {xs: 10, sm: 3}, marginTop: {xs: 2, md: 0} }} size={{ xs:12, sm:4 }} >
            <Link variant="body1" component="button" onClick={() => navigate("/ayuda")} underline="none" color="textSecondary">
              Ayuda
            </Link><br />
            <Link variant="body1" component="button" onClick={() => navigate("/soporte")} underline="none" color="textSecondary">
              Chat
            </Link><br />
            <Typography component="h2" className="titulo-footer">Contáctanos</Typography>
            <Link
              variant="body1"
              underline="none"
              color="textSecondary"
              href="https://wa.me/13124981712"
              target="_blank"
              rel="noopener noreferrer"
            >
              WhatsApp
            </Link>
          </Grid>
        </Grid>
      </Container>
      <SecondFooter />
    </Grid>
  );
}

export default Footer;